export type ErrorMessageKey =
  | "error_host"
  | "error_thunderbird_host"
  | "error_auth"
  | "error_no_message"
  | "error_selection_changed"
  | "error_read_email"
  | "error_report"
  | "error_report_unknown"
  | "error_delete"
  | "error_delete_permission"
  | "error_delete_not_found"
  | "error_configuration";

/** User-facing keys and safe diagnostic metadata, never a raw server/Office error. */
export class AppError extends Error {
  constructor(
    readonly code: string,
    readonly messageKey: ErrorMessageKey,
    readonly retryable = true,
    readonly status?: number,
  ) {
    super(code);
    this.name = "AppError";
  }
}

export function asAppError(error: unknown, fallback: AppError): AppError {
  return error instanceof AppError ? error : fallback;
}
